import { useTranslation } from 'react-i18next';
import { Page } from '../components/forms';
import { Icon } from '../components/icons';
import { Button } from '../components/ui';

/** O3 · Too many tries: sign-in pauses on this phone until the time shown. */
export function SignInPaused({ until, onBack }: { until: Date; onBack: () => void }) {
  const { t, i18n } = useTranslation();
  const time = until.toLocaleTimeString(i18n.language === 'hi' ? 'hi-IN' : 'en-IN', {
    hour: 'numeric',
    minute: '2-digit',
  });
  return (
    <Page
      bar={t('signIn.bar')}
      back={{ label: t('signIn.back'), onClick: onBack }}
      labelledBy="paused-title"
      footer={
        <Button variant="secondary" onClick={onBack}>
          {t('paused.back')}
        </Button>
      }
    >
      <div className="status" role="alert">
        <span className="status__tile">
          <Icon name="lock" size={30} />
        </span>
        <h1 className="status__title" id="paused-title">
          {t('paused.title')}
        </h1>
        <p className="status__text">{t('paused.text')}</p>
      </div>
      <dl className="panel">
        <div className="panel__row">
          <dt>{t('paused.until')}</dt>
          <dd>{time}</dd>
        </div>
      </dl>
      <p className="hint">{t('paused.notYou')}</p>
    </Page>
  );
}
